<style lang="scss">
  @use "../../../../assets/css/design-system/colors";
  @use "../../../../assets/css/design-system/utils";

  .footer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: utils.in_rem(14px);
    gap: utils.in_rem(16px);
    background-color: colors.get(interfaceSwGrey_5);
  }
</style>

<script>
  import Button from "../../../atoms/Button.svelte";

  export let onApply = () => {};
  export let onCancel = () => {};
  export let applyButtonText = "Apply";
</script>

<div class="footer">
  <Button
    onclick={onCancel}
    kind="ghost-blue"
    size="large"
    style="width: 8.25rem">Cancel</Button
  >

  <Button onclick={onApply} kind="primary" size="large" style="width: 8.25rem"
    >{applyButtonText}</Button
  >
</div>
